import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  Table,
  TabPane,
  Badge,
} from "reactstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import BreadCrumb from "./BreadCrumb";
import classnames from "classnames";
import SimpleBar from "simplebar-react";

import { CurrentDate, PreviousDate } from "./DefaultDateSet";
import { addMonths } from "./FlatePicker";

//import images
import profileBg from "../../images/profile-bg.jpg";
import { LEAD_ACTIVITY, LEAD_DETAILS } from "../../helpers/url_helper";
import { APIClient } from "../../helpers/api_helper";
import EmployeeCallType from "./EmployeeCallType";
import { DatePicker } from "./Flatpicker";
import { formatDate } from "./FormDateTime";
import { CommanDataTables } from "./DashboardDataTbale";
import TeamSelect from "./TeamSelect";
import EmployeeSelect from "./EmployeeSelect";
import { formatToSystemTimezone } from "./ToCamelCase";
import moment from "moment";
import Loader from "./Loader";
const api = new APIClient();

const LeadDetails = () => {
  const id = localStorage.getItem("leadId");
  const navigate = useNavigate();

  // Date handling
  const previewsDate = PreviousDate();
  const currentDate = CurrentDate();
  const [selectedFromDate, setSelectedFromDate] = useState(previewsDate);
  const [selectedToDate, setSelectedToDate] = useState(currentDate);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedEmployeeOptions, setSelectedEmployeeOptions] = useState([]);
  const [selectedEmployeeOptions2, setSelectedEmployeeOptions2] = useState([]);
  // Tab state
  const [activeTab, setActiveTab] = useState("1");
  const [activeSubTab, setActiveSubTab] = useState("1");
  const [teamIndu, setTeamIndu] = useState([]);
  const [EmployeeDefaultWithoutTeam, setEmployeeDefaultWithoutTeam] = useState(
    []
  );
  // State for leads data
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [EmployeeData, setEmployeeData] = useState([]);

  // State for pagination
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);

  // State for filters
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState([]);
  const loginType = JSON.parse(localStorage.getItem("logintype"));
  const permissionType = JSON.parse(localStorage.getItem("permission"));
  const viewReportPermission = permissionType?.includes("VIEW_REPORT");
  const [leadActivity, setLeadActivity] = useState([]);
  const [leadId, setLeadId] = useState(id);
  const location = useLocation();

  // Toggle tabs
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  // Date handlers
  const handleFromDateChange = (dates) => {
    const newFromDate = dates[0];
    setSelectedFromDate(newFromDate);
    const today = new Date();

    const threeMonthsAfterFromDate = addMonths(newFromDate, 3);

    if (
      selectedToDate >= newFromDate &&
      selectedToDate <= threeMonthsAfterFromDate
    ) {
      return;
    }
    const newToDate =
      threeMonthsAfterFromDate > today ? today : threeMonthsAfterFromDate;
    setSelectedToDate(newToDate);
  };

  const handleToDateChange = (dates) => {
    const newToDate = new Date(dates);
    setSelectedToDate(newToDate);
  };

  const transformLeadData = (leads) => {
    let transformedData = [];

    leads.forEach((lead, leadIndex) => {
      if (lead.callLogs.length > 0) {
        lead.callLogs.forEach((callLog, logIndex) => {
          transformedData.push({
            _id: lead._id + "-" + logIndex, // Unique ID
            phone: lead.phone,
            status: lead.status,
            createdAt: lead.createdAt,
            totalAttempts: lead.totalAttempts,
            note: callLog.note || "-",
            recording: callLog?.recordingUrl,
            type: callLog.type,
            timestamp: formatToSystemTimezone(callLog.dateTime),
            fullName: callLog.employeeInfo.fullName,
              date: callLog.dateTime ? moment(callLog.dateTime).format("DD MMM YYYY") : "-",
            time: formatToSystemTimezone(callLog.dateTime) || "-",
            duration: new Date(callLog.duration * 1000).toISOString().slice(11, 19),
          });
        });
      } else {
        // If no call logs, create a placeholder row
        transformedData.push({
          _id: lead._id,
          phone: lead.phone,
          status: lead.status,
          createdAt: lead.createdAt,
          totalAttempts: lead.totalAttempts,
          note: "-",
          duration: "-",
          type: "-",
          timestamp: "-",
        });
      }
    });

    return transformedData;
  };

  // Apply transformation
  const leadTableData = transformLeadData(leads);

  // Columns definition for the DataTable
  const columnsLeadDetails = [
    {
      name: <span className="font-weight-bold fs-13">S No.</span>,
      selector: (row, index) => index + 1,
      sortable: false,
      width: "70px",
    },
    {
      name: <span className="font-weight-bold fs-13">Employee Name</span>,
      selector: (row) => row.fullName || "-",
      sortable: true,
      width: "150px",
    },
    {
      name: <span className="font-weight-bold fs-13">Call Type</span>,
      selector: (row) => row.type || "-",
      sortable: true,
      width: "120px",
    },
    {
      name: <span className="font-weight-bold fs-13">Call Recording</span>,
      width: "37%",
      selector: (row) => (
        <>
          {row?.recording ? (
            <div
              style={{
                display: "inline-grid",
                marginBottom: "20px",
                marginTop: "10px",
              }}
            >
              <span style={{ height: "10px" }}>{row?.duration}</span>
              <audio
                style={{ height: "40px", marginTop: "15px" }}
                src={row?.recording}
                controls
              />
            </div>
          ) : row?.duration && row.duration !== "00:00:00" ? (
            <div
              style={{
                display: "inline-grid",
                marginBottom: "20px",
                marginTop: "10px",
              }}
            >
              {["OUTGOING", "INCOMING", "REJECTED", "MISSED"].includes(
                row.type
              ) ? (
                <>
                  <span style={{ height: "10px" }}>{row?.duration}</span>
                  <span style={{ marginTop: "10px", color: "warning" }}>
                    Recording sync in progress...
                  </span>
                </>
              ) : (
                "Call Not Connected"
              )}
            </div>
          ) : (
            "Call Not Connected"
          )}
        </>
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">Date & Time</span>,
      selector: (row) => new Date(`${row?.date} ${row?.time}`).getTime(), // Timestamp for sorting
      cell: (row) => (
        <div className="mt-2 mb-2">
          <h5
            className="font-weight-bold fs-13"
            style={{ textTransform: "capitalize" }}
          >
            {row?.date}
          </h5>
          <h6 className="text-center font-weight-bold fs-13">{row?.time}</h6>
        </div>
      ),
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Notes</span>,
      selector: (row) => row.note || "-",
      sortable: true,
      width: "100px",
    },
  ];

  // API call for fetching lead details
  const fetchLeadDetails = async (
    page = 1,
    size = 10,
    searchTerm = "",
    filters = {}
  ) => {
    try {
      setLoading(true);

      // Build query params
      const queryParams = new URLSearchParams();
      queryParams.append("pg", page);
      queryParams.append("lm", size);

      if (searchTerm) {
        queryParams.append("query", searchTerm);
      }

      // Prepare request data with filters and properly formatted dates
      const requestData = {
        leadId: id,
        startDate: formatDate(selectedFromDate),
        endDate: formatDate(selectedToDate),
        callType:
          filters.callType ||
          selectedOptions?.map((option) => option?.value) ||
          [],
        employeeIds: selectedEmployeeOptions?.map((userid) => userid?.id) || [],
      };

      // Make the API call
      const response = await api.create(`${LEAD_DETAILS}`, requestData);

      // Check if the response was successful
      if (
        response &&
        response.message === "Lead details retrieved successfully"
      ) {
        setLeads(response.data);
        setTotalRows(response.totalCount || response.data.length);
        return response.data;
      } else {
        // Handle error
        console.error("Failed to fetch lead details:", response.message);
        return [];
      }
    } catch (error) {
      console.error("Error fetching lead details:", error);
      return [];
    } finally {
      setLoading(false);
    }
  };

  // Handle page change
  const handlePageChange = (page) => {
    setPage(page);
  };

  // Handle rows per page change
  const handlePerRowsChange = (newPerPage, page) => {
    setSize(newPerPage);
  };

  // Handle filter change
  const handleFilterChange = async () => {
    setLoading(true); // Start loader
    try {
      const response = await fetchLeadDetails(); // Your data fetching function
      setLeads(response); // Set data to leads
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setLoading(false); // Stop loader
    }
  };

  // Handle search
  const handleSearch = (e) => {
    const value = e.target.value || "";
    setSearchTerm(value);

    if (e.key === "Enter") {
      handleFilterChange();
    }
  };

  // Reset filters
  const resetFilters = () => {
    setSelectedFromDate([]);
    setSelectedToDate([]);
    setSelectedOptions([]);
    setSearchTerm("");
    setStatusFilter([]);
    setSelectedEmployeeOptions([])
    setTeamIndu([])
  };

  // Load data on component mount and when filters change
  useEffect(() => {
    // Initial load with default filters
    const initialFilters = {
      startDate: selectedFromDate,
      endDate: selectedToDate,
      callType: selectedOptions,
      employeeIds: selectedEmployeeOptions?.map((userid) => userid?.id),
    };

    fetchLeadDetails(page, size, searchTerm, initialFilters);

  }, [page, size,selectedEmployeeOptions2]);

  const getInitials = (firstName, lastName) => {
    const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : "";
    const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : "";
    return `${firstInitial}${lastInitial}`;
  };

  useEffect(() => {
    const fetchLeadActivity = async () => {
      try {
        setLoading(true);
        // Assuming your API endpoint returns the data structure shown in the example
        const response = await api.create(`${LEAD_ACTIVITY}`, { leadId });

        if (response.success == true) {
          const formattedData = response.data.activityData.map((item) => ({
            id: item._id,
            note: item.note || "No note available",
            status: item.leadStatus || "No status update",
            updatedAt: item.updatedAt
              ? new Date(item.updatedAt).toLocaleString()
              : "-",
            assignedTo: item.employeeDetails ? item.employeeDetails : null,
            type: item.type || "Admin",
          }));
          setLeadActivity(formattedData);
        }
      } catch (error) {
        console.error("Error fetching lead activity:", error);
      } finally {
        setLoading(false);
      }
    };

    if (leadId) {
      fetchLeadActivity();
    }
  }, [leadId]);


  return (
    <div className="page-content sn-lead-detail-top">
      <Container fluid>
        <Row>
          <BreadCrumb title="Lead Details" pageTitle="Lead Details" />
        </Row>

        <Row>
          <Card className="">
            <React.Fragment>
              <div className="page-content pt-5">
                <Container fluid>
                  {/* Profile Background Section */}
                  <div className="position-relative mx-n4 mt-n4">
                    <div className="profile-wid-bg profile-setting-img">
                      <img
                        src={profileBg}
                        alt="Profile Background"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "4px",
                        }}
                      />
                      <div className="overlay-content">
                        <div className="text-end p-3">
                          <div className="p-0 ms-auto rounded-circle profile-photo-edit">
                            <Input
                              id="profile-foreground-img-file-input"
                              type="file"
                              className="profile-foreground-img-file-input"
                            />
                            <Label
                              htmlFor="profile-foreground-img-file-input"
                              className="profile-photo-edit btn btn-light"
                            >
                              <i className="ri-image-edit-line align-bottom me-1"></i>{" "}
                              Change Cover
                            </Label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Row>
                    {/* Profile Sidebar */}
                    <Col xxl={3}>
                      <Card className="mt-n5">
                        <CardBody className="p-4">
                          <div className="text-center">
                          <div className="flex-shrink-0 text-end">
                          <Link
                             to="/edit-Lead"
                             state={{ leadData: leads[0] }} // Pass the specific lead object
                             className="badge bg-light text-primary fs-12"
                           >
                             <i className="ri-edit-box-line align-bottom me-1"></i>{" "}
                             Edit
                           </Link>
                          </div>
                            <div className="profile-user position-relative d-inline-block mx-auto mb-4">
                              <div className="rounded-circle avatar-xl img-thumbnail bg-danger d-flex align-items-center justify-content-center text-white font-weight-bold">
                                <span className="fs-1">
                                  {getInitials(
                                    leads[0]?.firstName,
                                    leads[0]?.lastName
                                  )}
                                </span>
                              </div>
                            </div>
                            <h5 className="mb-1">
                              {leads[0]?.firstName} <span></span>{" "}
                              {leads[0]?.lastName}
                            </h5>
                            <p className="text-muted">
                              <i className="ri-phone-line"></i>{" "}
                              {leads[0]?.phone}
                            </p>
                          </div>

                          <div className="live-preview mt-4">
                            <div className="table-responsive mt-4">
                              <Table className="table-bordered table-nowrap align-middle mb-0">
                                <thead>
                                  <tr>
                                    <th scope="col">Status</th>
                                    <th scope="col">Tags</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td className="fw-semibold">
                                      {leads[0]?.status
                                        ? leads[0]?.status
                                        : "-"}
                                    </td>
                                    <td>No tags for lead</td>
                                  </tr>
                                </tbody>
                              </Table>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>

                    {/* Main Content Area */}
                    <Col xxl={9}>
                      <Card className="mt-xxl-n5">
                        <CardHeader className="sn-lead-detail-tab-top">
                          <Nav
                            className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
                            role="tablist"
                          >
                            <NavItem>
                              <NavLink
                                className={classnames({
                                  active: activeTab === "1",
                                })}
                                onClick={() => {
                                  toggleTab("1");
                                }}
                              >
                                <i className="fas fa-home"></i>
                                View Lead
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                className={classnames({
                                  active: activeTab === "2",
                                })}
                                onClick={() => {
                                  toggleTab("2");
                                }}
                                type="button"
                              >
                                <i className="far fa-user"></i>
                                Lead Assignment Activity
                              </NavLink>
                            </NavItem>
                          </Nav>
                        </CardHeader>

                        <CardBody className="p-4">
                          <TabContent activeTab={activeTab}>
                            {/* View Lead Tab */}
                            <TabPane tabId="1">
                              <Form>
                                <Row>
                                  <Col lg={12}>
                                    <div className="border-bottom pb-2 mb-4">
                                      <Row className="sn">
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xs-12">
                                          <DatePicker
                                            className="w-100 snlead-filter-header"
                                            labelContent="From Date"
                                            getDate={selectedFromDate}
                                            options={{
                                              disable: [
                                                {
                                                  from: new Date(),
                                                },
                                              ],
                                              dateFormat: "Y-m-d",
                                              altInput: true, // Enables an alternative input field for formatted display
                                              altFormat: "d M, Y",
                                              maxDate: new Date(
                                                new Date().setDate(
                                                  new Date().getDate()
                                                )
                                              ),
                                            }}
                                            onChange={handleFromDateChange}
                                          />
                                        </div>

                                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xs-12">
                                          <DatePicker
                                            className="w-100 snlead-filter-header"
                                            labelContent="To Date"
                                            getDate={selectedToDate}
                                            options={{
                                              enable: selectedFromDate
                                                ? [
                                                    {
                                                      from: selectedFromDate,
                                                      to: addMonths(
                                                        selectedFromDate,
                                                        3
                                                      ),
                                                    },
                                                  ]
                                                : [
                                                    {
                                                      from: new Date(),
                                                    },
                                                  ],
                                              dateFormat: "Y-m-d",
                                              altInput: true, // Enables an alternative input field for formatted display
                                              altFormat: "d M, Y",
                                              maxDate:
                                                selectedFromDate === new Date()
                                                  ? new Date()
                                                  : selectedToDate,
                                            }}
                                            onChange={handleToDateChange}
                                          />
                                        </div>

                                        {((viewReportPermission &&
                                          loginType === "employee") ||
                                          loginType === "organization") && (
                                          <div className="col-md-3 col-sm-12">
                                            <TeamSelect
                                              setSelectedEmployeeOptions={
                                                setSelectedEmployeeOptions
                                              }
                                              teamIndu={teamIndu}
                                              setTeamIndu={setTeamIndu}
                                              labelContent="Select Team"
                                            />
                                          </div>
                                        )}

                                        {((viewReportPermission &&
                                          loginType === "employee") ||
                                          loginType === "organization") && (
                                          <div className="col-md-3 col-sm-12">
                                            <EmployeeSelect
                                              setEmployeeDefaultWithoutTeam={
                                                setEmployeeDefaultWithoutTeam
                                              }
                                              EmployeeDefaultWithoutTeam={
                                                EmployeeDefaultWithoutTeam
                                              }
                                              error={error}
                                              setError={setError}
                                              EmployeeDefault={
                                                teamIndu.length === 0
                                                  ? EmployeeDefaultWithoutTeam
                                                  : EmployeeData
                                              }
                                              setEmployeeDefault={
                                                setEmployeeData
                                              }
                                              teamIndu={teamIndu}
                                              selectedEmployeeOptions={
                                                selectedEmployeeOptions
                                              }
                                              setSelectedEmployeeOptions={
                                                setSelectedEmployeeOptions
                                              }
                                              setSelectedEmployeeOptions2={
                                                setSelectedEmployeeOptions2
                                              }
                                              labelContent="Select Employee"
                                            />
                                          </div>
                                        )}

                                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 sn-header-select-employess-home">
                                          <FormGroup>
                                            <EmployeeCallType
                                              labelContent="Select Call Type"
                                              selectedOptions={selectedOptions}
                                              setSelectedOptions={
                                                setSelectedOptions
                                              }
                                            />
                                          </FormGroup>
                                        </div>

                                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xs-12">
                                          <FormGroup>
                                            <Label for="exampleSelect"></Label>
                                            <div
                                              id="exampleSelect"
                                              className="sn-call-apply-btn-reset mt-2"
                                            >
                                              <Button
                                                type="button"
                                                color="danger"
                                                className=""
                                                onClick={handleFilterChange}
                                              >
                                                Apply
                                              </Button>
                                              <Button
                                                className=""
                                                style={{
                                                  marginLeft: "10px",
                                                }}
                                                type="button"
                                                outline
                                                color="danger"
                                                onClick={resetFilters}
                                              >
                                                Reset
                                              </Button>
                                            </div>
                                          </FormGroup>
                                        </div>
                                      </Row>
                                      </div>
                                      <TabContent activeTab={activeSubTab}>
                                        {/* Lead Details Sub Tab */}
                                        <TabPane tabId="1">
                                          <Row>
                                          <Col>
                                          {loading ? (
                                           <div className="text-center p-4">
                                         <Loader/>    </div>
                                         ) : leads.length > 0 && leads.some(lead => lead.callLogs && lead.callLogs.length > 0) ? (
                                           <CommanDataTables
                                             column={columnsLeadDetails}
                                             tableData={leadTableData}
                                             onChangePage={handlePageChange}
                                             onChangeRowsPerPage={handlePerRowsChange}
                                             handleSearch={handleSearch}
                                             isLoading={loading}
                                             noData="Lead not found"
                                           />
                                         ) : (
                                           <div className="text-center p-4">
                                             <div className="avatar-md mx-auto mb-4">
                                               <div className="avatar-title bg-light rounded-circle text-primary fs-24">
                                                 <i className="ri-file-list-3-line"></i>
                                               </div>
                                             </div>
                                             <h5>No Data Found</h5>
                                           </div>
                                         )} 
                                     </Col>
                                        </Row>
                                      </TabPane>
                                    </TabContent>
                                  </Col>
                                </Row>
                              </Form>
                            </TabPane>

                            {/* Lead Assignment Activity Tab */}
                            <TabPane tabId="2">
                              <Col>
                                <div className="">
                                  <div className="d-flex flex-wrap align-items-start gap-3">
                                    <h5 className="fs-14 fw-bold">
                                      Assignment History:{" "}
                                    </h5>
                                  </div>

                                  <SimpleBar
                                    className="me-lg-n3 pe-lg-4"
                                    style={{ maxHeight: "550px" }}
                                  >
                                    {leadActivity.length > 0 ? (
                                      <ul className="list-unstyled mb-0">
                                        {leadActivity.map((item, index) => (
                                          <li
                                            className="py-2"
                                            key={item.id || index}
                                          >
                                            <div className="border border-dashed rounded p-3">
                                              <div className="d-flex align-items-start mb-3">
                                                <div className="flex-grow-1">
                                                  <div className="d-flex justify-content-between mb-2">
                                                    <span className="badge rounded-pill bg-light text-dark">
                                                      {item.updatedAt}
                                                    </span>
                                                    {item.status && (
                                                      <span
                                                        className={`badge rounded-pill ${
                                                          item.status ===
                                                          "Contacted"
                                                            ? "bg-success"
                                                            : "bg-secondary"
                                                        }`}
                                                      >
                                                        {item.status}
                                                      </span>
                                                    )}
                                                  </div>

                                                  <p className="mb-1">
                                                    <strong>Note:</strong>{" "}
                                                    {item.note}
                                                  </p>

                                                  {item.assignedTo && (
                                                    <div className="mt-2 d-flex align-items-center">
                                                      <div className="avatar-xs me-2">
                                                        <span className="avatar-title rounded-circle bg-light text-primary">
                                                          {item.assignedTo.fullName.charAt(
                                                            0
                                                          )}
                                                        </span>
                                                      </div>
                                                      <div>
                                                        <p className="mb-0 fw-medium">
                                                          {
                                                            item.assignedTo
                                                              .fullName
                                                          }
                                                        </p>
                                                        <p className="text-muted small mb-0">
                                                          {
                                                            item.assignedTo
                                                              .mobileNumber
                                                          }
                                                        </p>
                                                      </div>
                                                    </div>
                                                  )}
                                                {/* Show updated by information based on type */}
                                                <div className="mt-2 text-muted small">
                                                <strong>Updated by:</strong>{" "}
                                                {item.type === "employee" ? 
                                                  `${item.updatedBy?.fullName || "Employee"}` : 
                                                  `${item.organization?.name || "Organization"}`
                                                }
                                                </div>
                                                </div>
                                              </div>
                                            </div>
                                          </li>
                                        ))}
                                      </ul>
                                    ) : (
                                      <div className="text-center p-4">
                                        <div className="avatar-md mx-auto mb-4">
                                          <div className="avatar-title bg-light rounded-circle text-primary fs-24">
                                            <i className="ri-file-list-3-line"></i>
                                          </div>
                                        </div>
                                        <h5>No activity records found</h5>
                                      </div>
                                    )}
                                  </SimpleBar>
                                </div>
                              </Col>
                            </TabPane>
                          </TabContent>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Container>
              </div>
            </React.Fragment>
          </Card>
        </Row>
      </Container>
    </div>
  );
};

export default LeadDetails;
